var map = {
	"./Card or Apple Pay_move.png": "b36d",
	"./PayPal_move.png": "8256",
	"./alipay_move.png": "c66b",
	"./codebg.png": "dbea",
	"./not_optional.png": "f1a5",
	"./order_invalid_move.png": "4446",
	"./payment_failure_move.png": "58fe",
	"./payment_success_move.png": "3483",
	"./paynow-lb.png": "eb37",
	"./paynow-logo.png": "f322",
	"./paynow-lt.png": "fb3e",
	"./paynow-rb.png": "bbd2",
	"./paynow-rt.png": "f546",
	"./paynowLogo.png": "6b56",
	"./selection.png": "a1ae",
	"./switch_icon.png": "969a",
	"./unchecked.png": "fb91",
	"./wechat_move.png": "05a5",
	"./yw-logo.png": "6066"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "265a";